// src/app/services/-toolbar.service.ts
import { Injectable } from '@angular/core';
import { FormatOption, HeaderValue, ListOption, ScriptOption, IndentOption, DirectionOption, SizeOption, ToolbarOptions } from './text-editor-toolbar.types';

export interface ToolbarBuilderOptions {
    formatting?: boolean;
    lists?: boolean;
    headers?: boolean;
    links?: boolean;
    images?: boolean;
    colors?: boolean;
    blockquote?: boolean;
    align?: boolean;
  }

export class TextEditorToolbarUtils {
  public static FULL_TOOLBAR: ToolbarOptions = [
    [FormatOption.BOLD, FormatOption.ITALIC, FormatOption.UNDERLINE, FormatOption.STRIKE],
    [FormatOption.BLOCKQUOTE, FormatOption.CODE_BLOCK],
    [{ header: HeaderValue.H1 }, { header: HeaderValue.H2 },{ header: HeaderValue.H3 }],
    [{ list: ListOption.ORDERED }, { list: ListOption.BULLET }],
    [{ script: ScriptOption.SUB }, { script: ScriptOption.SUPER }],
    [{ indent: IndentOption.DECREASE }, { indent: IndentOption.INCREASE }],
    [{ direction: DirectionOption.RTL }],
    [{ size: [SizeOption.SMALL, false, SizeOption.LARGE, SizeOption.HUGE] }],
    [{ header: [HeaderValue.H1, HeaderValue.H2, HeaderValue.H3, HeaderValue.H4, HeaderValue.H5, HeaderValue.H6, false] }],
    [{ color: [] }, { background: [] }],
    [{ font: [] }],
    [{ align: [] }],
    [FormatOption.CLEAN],
    [FormatOption.LINK, FormatOption.IMAGE]
  ];

  public static BASIC_TOOLBAR: ToolbarOptions = [
    [FormatOption.BOLD, FormatOption.ITALIC, FormatOption.UNDERLINE],
    [{ header: [false, HeaderValue.H1, HeaderValue.H2, HeaderValue.H3, HeaderValue.H4] }],
    [FormatOption.BLOCKQUOTE, FormatOption.CODE_BLOCK],
    [{ align: [] }],
    [{ list: ListOption.ORDERED }, { list: ListOption.BULLET }],
    [FormatOption.LINK, FormatOption.IMAGE]
  ];

  public static MINIMAL_TOOLBAR: ToolbarOptions = [
    [FormatOption.BOLD, FormatOption.ITALIC, FormatOption.UNDERLINE],
    [{ header: [false, HeaderValue.H1, HeaderValue.H2, HeaderValue.H3, HeaderValue.H4] }],
    [FormatOption.BLOCKQUOTE, FormatOption.CODE_BLOCK],
    [{ align: [] }],
    [{ list: ListOption.ORDERED }, { list: ListOption.BULLET }],
    [FormatOption.LINK]
  ];

  public static EMPTY_TOOLBAR: ToolbarOptions = [];

  // Method to build a custom toolbar
  public static buildCustomToolbar(options: ToolbarBuilderOptions): ToolbarOptions {
    const toolbar: ToolbarOptions = [];
    
    if (options.formatting) {
      toolbar.push([FormatOption.BOLD, FormatOption.ITALIC, FormatOption.UNDERLINE]);
    }
    
    if (options.lists) {
      toolbar.push([
        { list: ListOption.ORDERED }, 
        { list: ListOption.BULLET }
      ]);
    }
    
    if (options.headers) {
      toolbar.push([{ 
        header: [
          HeaderValue.H1, 
          HeaderValue.H2, 
          HeaderValue.H3, 
        ] 
      }]);
    }
    
    if (options.links) {
      toolbar.push([FormatOption.LINK]);
    }
    
    if (options.images) {
      toolbar.push([FormatOption.IMAGE]);
    }
    
    if (options.colors) {
      toolbar.push([{ color: [] }, { background: [] }]);
    }
    
    if (options.blockquote) {
      toolbar.push([FormatOption.BLOCKQUOTE]);
    }
    
    if (options.align) {
      toolbar.push([{ align: [] }]);
    }
    
    return toolbar;
  }
}